import { render, staticRenderFns } from "./scorder.vue?vue&type=template&id=4b5aa64d&scoped=true"
import script from "./scorder.vue?vue&type=script&lang=js"
export * from "./scorder.vue?vue&type=script&lang=js"
import style0 from "./scorder.vue?vue&type=style&index=0&id=4b5aa64d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5aa64d",
  null
  
)

export default component.exports